import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as moment from 'moment'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import JsonEditor from 'vue-json-edit'

Vue.use(BootstrapVue)

Vue.config.productionTip = false
  
Vue.use(JsonEditor)

function isJSON (jsonString){
  try {
      var o = JSON.parse(jsonString)
      if (o && typeof o === "object") {
          return true
      }
  }
  catch (e) { }
  return false
}
if (document.URL.includes('8080')) {
  //isDev
  console.log('isDev')
  store.set('apiUrl', 'http://localhost:3001/api/')
} else {
  //isLive
  console.log('isLive')
  store.set('apiUrl', 'https://desk.hotelieroapp.com/api/')
}
// store.set('apiUrl', 'https://desk.hotelieroapp.com/api/')

// let authToken = window.localStorage.getItem('accessToken')
// store.set('dashboard', JSON.parse(cacheDashboard))

// check if token is present
let token = window.localStorage.getItem('crm')
if (token === null) {
  console.log('Token not exist')
  store.set('isAuthenticated', true) // false -> true
}

// check if string is json
if (isJSON(token)) {
  console.log('Token exists')
  // set to vuex
  let tmp = JSON.parse(token)
  store.set('u', tmp.u)  
  store.set('token', tmp.token)
  store.set('crmTokenValidTill', tmp.validTill)
  store.set('isAuthenticated', true)
  let validTill = moment(tmp.validTill)
  let now = moment()
  let duration = parseInt(validTill.diff(now, 'minutes'))
  console.log('Token expire in', duration, 'minutes')
  if (duration < 2460) {
    console.log('refresh token')
    // call api with token
    // store result to localstorage
    // update vuex
  }
}
store.set('isOnline', true)
console.log('aaaa', window.localStorage.getItem('crm111'))
      //  window.localStorage.setItem('crm', JSON.stringify(response.data))
console.log(store.state.isAuthenticated)

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
	next ()
	/*
console.log(to)
  if(to.path == '/login') { // check if "to"-route is "callback" and allow access
    next()
  } else if (store.state.isAuthenticated) { // if authenticated allow access
    next()
  } else { // trigger login
    router.push({name:"login"})
  }
*/
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
